/**
 * 翻页组件
 *
 */

import Page from './src/Page.vue'
Page.install = Vue => Vue.component(Page.name, Page)
export default Page
